import web from "../../Images/img1.jpg";
import app from "../../Images/img2.jpg";
import software from "../../Images/img3.jpg";
import digital from "../../Images/img4.jpg";
import andriod from "../../Images/img5.jpg";
import marketing from "../../Images/img6.jpg";

const CardData = [
    {
        imgsrc: web,
        title: "Web Development",
        description: "Web development services help create all types of web-based software and ensure great experience for web users."
    },
    {
        imgsrc: app,
        title: "App Development",
        description: "Web development services help create all types of web-based software and ensure great experience for web users."
    },
    {
        imgsrc: software,
        title: "Software Development",
        description: "Web development services help create all types of web-based software and ensure great experience for web users."
    },
    {
        imgsrc: digital,
        title: "Digital Marketing",
        description: "Web development services help create all types of web-based software and ensure great experience for web users."
    },
    {
        imgsrc: andriod,
        title: "Andriod Development",
        description: "Web development services help create all types of web-based software and ensure great experience for web users."
    },
    {
        imgsrc: marketing,
        title: "Marketing",
        description: "Web development services help create all types of web-based software and ensure great experience for web users."
    },
]

export default CardData;